import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './shippingNotices.html'

/**
 * Shipment (Shipping Notice) Report route
 *
 * @namespace routes.ReportShippingNotices
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.shippingNotices.list',
  label: 'REPORT.SHIPPINGNOTICES.TITLE',
  url: '/shipments/notices',
  component: 'tmrReportShippingNotices',
  weight: 10,
  resourceType: 'ShippingNotice',
  resourceList: {
    searchParameters: [
      'code',
      'creationDate.from',
      'creationDate.to',
      'originPlace.id',
      'destinationPlace.id',
      'state',
    ],
  },
  resolve: {
    shippingNoticeStates: /*@ngInject*/ tmrShippingNoticeStates =>
      tmrShippingNoticeStates,
  },
  accessControl: 'TmrShippingOperationsAccessControl',
  data: {
    capabilities: ['Resource.list', 'Resource.ShippingNotice.list'],
  },
}

/**
 * Component for {@link routes.tmrReportShippingNotices Shipping Notice route}
 *
 * @type {ngComponent}
 */
export const tmrReportShippingNotices = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings({
    shippingNoticeStates: '<',
  }),
}
